import axios from '../../../config/axios';

const API_BASE = `${process.env.REACT_APP_GATEWAY_BASE_URL}/financial/dre-line`;

export interface DreLine {
  id: number;
  name: string;
  code: string | null;
  description: string | null;
  status: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface DreLineListResponse {
  data: DreLine[];
  total: number;
  page: number;
  limit: number;
}

export interface DreLineListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'true' | 'false';
}

export interface DreLinePayload {
  name: string;
  code?: string;
  description?: string;
  status?: boolean;
}

export const dreLineApi = {
  list: async (params: DreLineListParams = {}): Promise<DreLineListResponse> => {
    const { data } = await axios.get<DreLineListResponse>(API_BASE, { params });
    return data;
  },

  getById: async (id: number): Promise<DreLine> => {
    const { data } = await axios.get<DreLine>(`${API_BASE}/${id}`);
    return data;
  },

  create: async (payload: DreLinePayload): Promise<DreLine> => {
    const { data } = await axios.post<DreLine>(API_BASE, payload);
    return data;
  },

  update: async (id: number, payload: DreLinePayload): Promise<DreLine> => {
    const { data } = await axios.patch<DreLine>(`${API_BASE}/${id}`, payload);
    return data;
  },

  remove: async (id: number): Promise<void> => {
    await axios.delete(`${API_BASE}/${id}`);
  },
};

export default dreLineApi;
